import { GameLiveConnection } from './GameLiveConnection';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { LiveUpdateConnectionMethod } from './types';
import { liveUpdateService } from '../liveUpdateService';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';
import { parseQuery } from '../../core/helpers/parseQuery';
import { applicationStore } from '../../store/applicationStore';
import { partnerSkinEnums } from '../../core/constants/partnerSkinEnums';
import { isPG } from '../../core/helpers/skinHelper';

export class LiveUpdateConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  sendGetInitialState(isInitial = true) {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    if (isInitial) {
      this.executeGameConnections();
    }
    const skin = isPG() ? partnerSkinEnums.pg : applicationStore.partnerSkin;
    this.getAllGameLiveBets();
    this.getLiveBetsByGame(gameId, skin);
    this.getHighRollersByGame(gameId, skin);
  }

  getAllGameLiveBets() {
    const skin = isPG() ? partnerSkinEnums.pg : applicationStore.partnerSkin;
    return super.invoke(LiveUpdateConnectionMethod.GetSpins, skin);
  }

  getLiveBetsByGame(...params) {
    super.invoke(LiveUpdateConnectionMethod.GetLiveBetsByGame, ...params);
  }

  getHighRollersByGame(...params) {
    super.invoke(LiveUpdateConnectionMethod.GetHighRollers, ...params);
  }

  checkResultHash(params) {
    super.invoke(LiveUpdateConnectionMethod.CheckResultHash, params);
  }

  sendExchangeAmount(model) {
    return this.invoke(LiveUpdateConnectionMethod.ExchangeAmount, model);
  }

  executeGameConnections() {
    super.onReconnected();
    super.onReconnecting();
    super.on(
      LiveUpdateConnectionMethod.LiveSpin,
      liveUpdateService.handleLiveSpinUpdate.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.SpinsResult,
      liveUpdateService.handleGetAllLiveBets.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.HighrollerResult,
      liveUpdateService.handleGetHighRollers.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.LiveBetsByGameResult,
      liveUpdateService.handleGetLiveBetsByGame.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.Highroller,
      liveUpdateService.handleUpdateHighRoller.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.CheckResultHashResult,
      liveUpdateService.handleCheckResultHashResult.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.ExchangeAmountResult,
      liveUpdateService.handleSetExchangeAmount.bind(liveUpdateService)
    );
  }
}

const { liveUpdateSocketUrl } = environmentBuilder();

export const liveUpdateConnection = new LiveUpdateConnection({ url: liveUpdateSocketUrl });
